module.exports = __webpack_public_path__ + "static/media/12_l_stena_0_0.c1cf3b8e.png";